/**
 * IMPORTS
 */

import { ISolicitacaoRemessaPayload } from "@/hooks/remessas/solicitar-remessa/index.d";

import { solicitarRemessaRepository } from "@/repositories/solicitar-remessa";

/**
 * Função que solicita remessas 🛠️.
 */
const handlerSolicitarRemessa = async (
  accessToken: string,
  payload: ISolicitacaoRemessaPayload
) => {
  return solicitarRemessaRepository.handlerSolicitarRemessa(accessToken, payload);
};

/**
 * EXPORTS
 */
export { handlerSolicitarRemessa };
